import type { LegalSection } from './legalMeta';
import { LEGAL_META } from './legalMeta';

export const communityGuidelinesTitle = 'Community Guidelines';

export const communityGuidelinesSections: LegalSection[] = [
  {
    id: 'purpose',
    title: 'Purpose',
    paragraphs: [
      `${LEGAL_META.brandMark} helps people share memories tied to places. These Community Guidelines explain what we expect from everyone and how we handle reports.`,
    ],
  },
  {
    id: 'respect',
    title: 'Be Respectful',
    paragraphs: [
      'Treat others with respect. Do not harass, bully, threaten, or target individuals or groups based on protected characteristics.',
    ],
  },
  {
    id: 'safety',
    title: 'Keep It Safe and Legal',
    paragraphs: ['Do not post content that:'],
    listItems: [
      'Is illegal or promotes illegal activity.',
      'Sexually exploits minors or endangers children in any way (zero tolerance).',
      'Is primarily pornographic or sexually explicit.',
      'Incites violence or hatred.',
      'Shares others’ private information without permission.',
    ],
  },
  {
    id: 'authentic',
    title: 'Authentic Memories',
    paragraphs: [
      'Share photos and captions that represent your experience. Do not spam, impersonate others, or mislead users about locations.',
    ],
  },
  {
    id: 'report',
    title: 'Reporting and Blocking',
    paragraphs: [
      'Use in-app reporting on posts, comments, or profiles where available.',
      'You can also email ' + LEGAL_META.supportEmail + ' with links or screenshots and a description of the issue.',
      'You may block users in the App to stop seeing their content in your feed.',
      'We aim to act on valid reports within 24 hours, including removing content and restricting accounts when appropriate.',
    ],
  },
  {
    id: 'enforcement',
    title: 'Enforcement',
    paragraphs: [
      'Violations may result in content removal, account suspension, or permanent ban.',
      'We may report illegal activity, including child safety matters, to authorities.',
    ],
  },
  {
    id: 'appeals',
    title: 'Appeals',
    paragraphs: [
      'If you believe we made a mistake, contact ' +
        LEGAL_META.contactEmail +
        ' within seven days with your username and details.',
    ],
  },
];
